import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router, { asyncRoutes, constantRoutes } from "./router";
import store from "./store";
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style

var routes_loaded = false;
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var title, token, allRoutes, notfoundRoutes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          NProgress.start();
          if (to.meta && to.meta.title) {
            title = to.meta.title;
            if (process.env.VUE_APP_NAME) {
              title = process.env.VUE_APP_NAME + ' - ' + title;
            }
            document.title = title;
          }
          if (!(to.path === '/moa/logout')) {
            _context.next = 5;
            break;
          }
          store.dispatch('user/logout');
          return _context.abrupt("return");
        case 5:
          if (!(to.path === '/moa/login')) {
            _context.next = 8;
            break;
          }
          if (!to.query.token) {
            store.dispatch('user/login');
          } else {
            store.dispatch('user/update', to.query);
            next(to.query.route || '/');
            NProgress.done();
          }
          return _context.abrupt("return");
        case 8:
          token = store.state.user.token;
          if (!(!store.state.app.auth_disabled && !token)) {
            _context.next = 12;
            break;
          }
          store.dispatch('user/login', to.fullPath);
          return _context.abrupt("return");
        case 12:
          if (store.getters.currBiz) {
            _context.next = 15;
            break;
          }
          _context.next = 15;
          return store.dispatch('profile/refreshBiz');
        case 15:
          if (!routes_loaded) {
            _context.next = 19;
            break;
          }
          next();
          NProgress.done();
          return _context.abrupt("return");
        case 19:
          if (store.state.app.auth_disabled) {
            _context.next = 25;
            break;
          }
          _context.next = 22;
          return store.dispatch('user/refresh_token');
        case 22:
          if (store.state.user.token) {
            _context.next = 24;
            break;
          }
          return _context.abrupt("return");
        case 24:
          setInterval(function () {
            store.dispatch('user/refresh_token');
          }, 3600 * 1000);
        case 25:
          allRoutes = [].concat(_toConsumableArray(constantRoutes), _toConsumableArray(asyncRoutes));
          router.addRoutes(allRoutes);
          notfoundRoutes = [{
            path: '*',
            redirect: '/404'
          }];
          router.addRoutes(notfoundRoutes);
          allRoutes.push.apply(allRoutes, notfoundRoutes);
          store.commit('route/SET_ROUTES', allRoutes);
          routes_loaded = true;
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});